/* This file is autogenerated, see readme.md for instructions */
import ForceAddToRecallUndoSvgIcon from '@bloomreach/banana-theme/icons/force-add-to-recall-undo.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ForceAddToRecallUndoIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ForceAddToRecallUndoSvgIcon />
    </Icon>
  );
});

ForceAddToRecallUndoIcon.displayName = 'ForceAddToRecallUndoIcon';

export default ForceAddToRecallUndoIcon;
